<template>
	<div id="app">
		<router-view
			v-wechat-title="$route.meta.title + title"
			v-if="isRouterAlive"
		/>
	</div>
</template>

<script>
// import func from 'vue-editor-bridge'
export default {
	name: "App",
	provide() {
		return {
			reload: this.reload,
		}
	},
	data() {
		return {
			// title: '-第三届中国（宜兴）耐火原料国际交易洽谈会暨耐火材料产业数字化发展论坛',
			title: "",
			isRouterAlive: true,
		}
	},
	methods: {
		reload() {
			this.isRouterAlive = false
			this.$nextTick(function() {
				this.isRouterAlive = true
			})
		},
	},
}
</script>

<style>
#app {
	font-family: "Avenir", Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
}
</style>
